import React from 'react'
import {
  Grid,  Typography } from '@mui/material'
import { map } from '@/utils/lodash'

const EndBuyerForm = ({ endBuyerFields, renderInputFields  }) => (
  <>
    <Grid container>
      <Grid size={12}>
        <Typography variant="h6">End Buyer</Typography>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={1}>
      {map(endBuyerFields, (field) =>
        renderInputFields(false)(field),
      )}
    </Grid>
  </>
)

export default EndBuyerForm
